import type { DanceSeoHead } from "../danceSeoTypes.js";

// vi translation of the English source (shared/danceSeoHeads/en.ts); numbers and limits must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Trình tạo video nhảy AI từ nhạc – Bắt đầu miễn phí",
    description:
      "Biến mọi bài hát thành video nhảy AI trọn vẹn. Solmi lên biên đạo cho từng đoạn, dựng storyboard từng cảnh, render cảnh nhảy và cảnh lip-sync. Bắt đầu miễn phí.",
    h1: "Trình tạo video nhảy AI – Biến mọi bài hát thành video nhảy",
  },
  photo: {
    title: "Làm ảnh nhảy bằng AI – Tạo điệu nhảy AI từ ảnh | Solmi",
    description:
      "Làm ảnh nhảy bằng AI: tải lên ảnh toàn thân, chọn động tác hoặc tải lên clip nhảy của bạn, thêm bài hát. Solmi khớp điệu nhảy với nhịp nhạc. Bắt đầu miễn phí.",
    h1: "Làm ảnh nhảy – Tạo điệu nhảy AI từ ảnh",
  },
  inbound:
    "Muốn người biểu diễn nhảy? [Trình tạo video nhảy AI](/ai-dance-video-generator) lên biên đạo cho từng đoạn của bài hát và render một video nhảy trọn vẹn.",
};

export default head;
